import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  // Lock body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  // Handle ESC key
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  return <AnimatePresence data-id="element-240">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/80 z-50 backdrop-blur-sm" aria-hidden="true" data-id="element-241" />

          {/* Modal Container */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-242">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-[#1e2d3d] w-full max-w-2xl max-h-[85vh] rounded-sm shadow-2xl border border-[#c9a04e]/20 flex flex-col pointer-events-auto" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-243">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-[#f5f0e8]/10 bg-[#1a2332]" data-id="element-244">
                <h2 id="modal-title" className="text-2xl font-serif text-[#f5f0e8]" data-id="element-245">
                  {title}
                </h2>
                <button onClick={onClose} className="text-[#8a9bb0] hover:text-[#c9a04e] transition-colors p-1" aria-label="Cerrar" data-id="element-246">
                  <X className="w-6 h-6" data-id="element-247" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 md:p-8 overflow-y-auto custom-scrollbar text-[#f5f0e8]/90 space-y-6 text-sm md:text-base leading-relaxed" data-id="element-248">
                {children}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}